import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Paper,
    Alert
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EventIcon from '@mui/icons-material/Event';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import AWS from 'aws-sdk';
import Footer from '../core/Footer';

class PublicEvents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            expanded: 'panel0'
        }
    }

    componentDidMount() {
        this.fetchImages();
    }

    handleAccordionChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    fetchImages = async () => {
        // Configure AWS SDK
        AWS.config.update({
            region: 'us-east-1',
            accessKeyId: "AKIAJTACW7QVN7PPWLYQ",
            secretAccessKey: "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",
        });
        const bucketName = "nashville-event"
        // Create a new S3 instance
        const s3 = new AWS.S3();

        // Fetch objects from the specified bucket
        try {
            const response = await s3.listObjects({ Bucket: bucketName }).promise();
            const imageUrls = response.Contents.map(
                (item) => `https://${bucketName}.s3.amazonaws.com/${item.Key}`
            );

            this.setState({ images: imageUrls })
        } catch (error) {
            console.error('Error fetching images from S3:', error);
        }
    };

    render() {
        const { images, expanded } = this.state;

        const events = [
            {
                id: 'panel0',
                year: '2025',
                title: '2025 Conference',
                host: 'Mesa Associates',
                location: 'Chattanooga, TN',
                attendees: 455,
                highlight: true,
                description: [
                    'The Mesa team broke all of our records this year. With 455 attendees and having to turn away an additional 35, this was one for the record books for us. Between the incredible venue and the awesome strength of Mesa\'s social media team, this was an incredible week. The team has upped our game and we have a lot to keep up to for 2026!'
                ],
                hasCarousel: true,
                images: images
            },
            {
                id: 'panel1a',
                year: '2024',
                title: '2024 Conference',
                host: 'Black & Veatch',
                location: 'Kansas City, MO',
                description: [
                    'The team at Black & Veatch did an amazing job putting on this conference in beautiful downtown Kansas City!',
                    'This was the first time we used a conference center for our event and it was spectacular.'
                ],
                hasCarousel: true,
                images: images
            },
            {
                id: 'panel1b',
                year: '2023',
                title: '2023 Nashville 10th Anniversary Event',
                host: 'POWER Engineers',
                location: 'Nashville, TN',
                description: [
                    'POWER Engineers went above and beyond to pull in a record breaking crowd to help celebrate 10 years of the SDSIC success! With a sold-out conference, the 4 days in Nashville were a Smashing success!',
                    'This was another record breaking attendance record.'
                ],
                hasCarousel: true,
                images: images
            },
            {
                id: 'panel1',
                year: '2022',
                title: '2022 Kansas City Fall Event',
                host: 'Burns & McDonnell',
                location: 'Kansas City, MO',
                description: [
                    'The team at Burns & McDonnell pulled out all the stops and held an incredible event over the span of 4 days. It was our first live event in over two years due to pandemic times and everyone sure was excited to get out in person and have some face to face conversations.',
                    'Here are some pictures so you can get a feel for the event.'
                ],
                hasCarousel: true,
                carouselImages: [
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221031_151014.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221031_151505.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221031_154157.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221101_101625.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221102_090559.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221102_093322.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221102_185343.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221103_103635.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221103_130703.jpg',
                    'https://sdsic-images.s3.amazonaws.com/FallEvent2022/eventPics/20221103_131230.jpg'
                ]
            },
            {
                id: 'panel2',
                year: '2022',
                title: '2022 Virtual Spring Event',
                isVirtual: true,
                description: [
                    'The pandemic was not fun for anyone but our volunteers kept things going during this time. We held spring and fall events thanks to our generous sponsor POWER Engineers who provided us with sponsorship dollars to pay for our zoom platform',
                    'Members can login to our website to view all the recordings from these sessions'
                ]
            },
            {
                id: 'panel3',
                year: '2021',
                title: '2021 Virtual Events',
                isVirtual: true,
                description: [
                    'The pandemic was not fun for anyone but our volunteers kept things going during this time. We held spring and fall events thanks to our generous sponsor POWER Engineers who provided us with sponsorship dollars to pay for our zoom platform',
                    'Members can login to our website to view all the recordings from these sessions'
                ]
            },
            {
                id: 'panel4',
                year: '2020',
                title: '2020 Virtual Events',
                isVirtual: true,
                description: [
                    'The pandemic was not fun for anyone but our volunteers kept things going during this time. We held spring and fall events thanks to our generous sponsor POWER Engineers who provided us with sponsorship dollars to pay for our zoom platform',
                    'Members can login to our website to view all the recordings from these sessions'
                ]
            },
            {
                id: 'panel5',
                year: '2019',
                title: '2019 New York City Spring Event',
                host: 'POWER Engineers and ConEd',
                location: 'New York City, NY',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel6',
                year: '2018',
                title: '2018 Alexandria Fall Event',
                host: 'Distran',
                location: 'Alexandria, VA',
                description: [
                    'The team at Distran rolled our the \'Martigra\' for the SDSIC and threw a spectacular event for us in 2018. They had all the trimmings of the best party in town.',
                    'Here are some pictures so you can get a feel for the event!'
                ],
                hasCarousel: true,
                carouselImages: [
                    'https://sdsic-images.s3.amazonaws.com/IMG_4818-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_4836-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_4875-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_4961-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_4968-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_4994-1024x768.jpg'
                ]
            },
            {
                id: 'panel17',
                year: '2018',
                title: '2018 Allentown Spring Event',
                host: 'PPL',
                location: 'Allentown, PA',
                description: [
                    'The folks at PPL put on an amazing event and handled the crowd exceptionally well during our three day event in Allentown. They even had us over to their PPL Center for an after hours event.',
                    'Here are some pictures so you can get a feel for the event.'
                ],
                hasCarousel: true,
                carouselImages: [
                    'https://sdsic-images.s3.amazonaws.com/IMG_3442-1-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3448-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3459-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3467-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3481-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3484-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3494-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3500-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_3505-1024x768.jpg',
                    'https://sdsic-images.s3.amazonaws.com/IMG_5029-1024x768.jpg'
                ]
            },
            {
                id: 'panel7',
                year: '2017',
                title: '2017 San Diego Fall Event',
                host: 'Southern California Edison and Autodesk',
                location: 'San Diego, CA',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel8',
                year: '2017',
                title: '2017 St. Louis Spring Event',
                host: 'Ameren',
                location: 'St. Louis, MO',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel9',
                year: '2016',
                title: '2016 Kansas City Fall Event',
                host: 'Burns & McDonnell',
                location: 'Kansas City, MO',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel19',
                year: '2016',
                title: '2016 Birmingham Spring Event',
                host: 'Southern Company and Autodesk',
                location: 'Birmingham, AL',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel10',
                year: '2015',
                title: '2015 San Francisco Fall Event',
                host: 'Autodesk',
                location: 'San Francisco, CA',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel11',
                year: '2015',
                title: '2015 New Orleans Spring Event',
                host: 'Entergy and Autodesk',
                location: 'New Orleans, LA',
                description: ['Pictures and presentations from this event will be loaded up shortly. Please check back.']
            },
            {
                id: 'panel12',
                year: '2014',
                title: '2014 Nashville Inaugural Event',
                host: 'Nashville Electric Services and Autodesk',
                location: 'Nashville, TN',
                inaugural: true,
                description: ['Our very first event was held in Nashville and hosted by Nashville Electric Services and Autodesk']
            }
        ];

        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 6, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <EventIcon sx={{ fontSize: 64 }} />
                            <Box>
                                <Typography variant="h2" component="h1" sx={{ fontWeight: 700, mb: 0.5 }}>
                                    Past SDSIC Events
                                </Typography>
                                <Typography variant="h5" sx={{ opacity: 0.9 }}>
                                    A Decade of Innovation & Collaboration
                                </Typography>
                            </Box>
                        </Box>

                        <Alert severity="info" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.15)', color: 'white', '& .MuiAlert-icon': { color: 'white' } }}>
                            Mesa Associates just hosted our 2025 conference in Chattanooga and we had 455 attendees join us.
                            Find more information below on the '2025 Conference' tab. To view presentations from this year's event, login to this site.
                        </Alert>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ mb: 6 }}>
                    {events.map((event) => (
                        <Accordion
                            key={event.id}
                            expanded={expanded === event.id}
                            onChange={this.handleAccordionChange(event.id)}
                            elevation={3}
                            sx={{
                                mb: 3,
                                borderRadius: 3,
                                overflow: 'hidden',
                                '&:before': {
                                    display: 'none',
                                },
                                '&.Mui-expanded': {
                                    margin: '0 0 24px 0',
                                },
                                ...(event.highlight && {
                                    border: '3px solid #FF6600'
                                })
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ fontSize: 32, color: event.highlight ? '#FF6600' : '#003E7E' }} />}
                                sx={{
                                    backgroundColor: expanded === event.id
                                        ? (event.highlight ? '#FF6600' : '#003E7E')
                                        : (event.highlight ? 'rgba(255, 102, 0, 0.05)' : 'rgba(0, 62, 126, 0.02)'),
                                    color: expanded === event.id ? 'white' : '#003E7E',
                                    minHeight: 80,
                                    '&.Mui-expanded': {
                                        minHeight: 80,
                                    },
                                    '& .MuiAccordionSummary-content': {
                                        alignItems: 'center',
                                        gap: 2,
                                        my: 2
                                    },
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, flexWrap: 'wrap' }}>
                                    {event.isVirtual ? (
                                        <OndemandVideoIcon sx={{ fontSize: 40, color: expanded === event.id ? 'white' : '#003E7E' }} />
                                    ) : event.hasCarousel ? (
                                        <PhotoLibraryIcon sx={{ fontSize: 40, color: expanded === event.id ? 'white' : (event.highlight ? '#FF6600' : '#003E7E') }} />
                                    ) : (
                                        <EventIcon sx={{ fontSize: 40, color: expanded === event.id ? 'white' : '#003E7E' }} />
                                    )}
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                                            {event.title}
                                        </Typography>
                                        {event.host && (
                                            <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                                Hosted by {event.host}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                        <Chip
                                            label={event.year}
                                            sx={{
                                                backgroundColor: expanded === event.id ? 'rgba(255, 255, 255, 0.3)' : (event.highlight ? '#FF6600' : '#003E7E'),
                                                color: 'white',
                                                fontWeight: 700
                                            }}
                                        />
                                        {event.inaugural && (
                                            <Chip
                                                label="Inaugural"
                                                sx={{
                                                    backgroundColor: expanded === event.id ? 'rgba(255, 255, 255, 0.3)' : '#FF6600',
                                                    color: 'white',
                                                    fontWeight: 700
                                                }}
                                            />
                                        )}
                                        {event.attendees && (
                                            <Chip
                                                label={`${event.attendees} Attendees`}
                                                sx={{
                                                    backgroundColor: expanded === event.id ? 'rgba(255, 255, 255, 0.3)' : '#FF6600',
                                                    color: 'white',
                                                    fontWeight: 700
                                                }}
                                            />
                                        )}
                                        {event.isVirtual && (
                                            <Chip
                                                label="Virtual"
                                                sx={{
                                                    backgroundColor: expanded === event.id ? 'rgba(255, 255, 255, 0.3)' : '#666',
                                                    color: 'white',
                                                    fontWeight: 700
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails sx={{ p: 4 }}>
                                {event.location && (
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E', mb: 2 }}>
                                        {event.location}
                                    </Typography>
                                )}

                                {event.description.map((paragraph, idx) => (
                                    <Typography
                                        key={idx}
                                        variant="body1"
                                        sx={{ mb: 2, lineHeight: 1.8, fontSize: '1.05rem' }}
                                    >
                                        {paragraph}
                                    </Typography>
                                ))}

                                {event.hasCarousel && (
                                    <Paper
                                        elevation={4}
                                        sx={{
                                            mt: 3,
                                            borderRadius: 3,
                                            overflow: 'hidden',
                                            border: `3px solid ${event.highlight ? '#FF6600' : '#003E7E'}`
                                        }}
                                    >
                                        <Carousel
                                            dynamicHeight
                                            showThumbs={false}
                                            infiniteLoop
                                            autoPlay
                                            interval={5000}
                                        >
                                            {(event.carouselImages || event.images).map((url, index) => (
                                                <div key={index}>
                                                    <img src={url} alt={`${event.title} - Photo ${index + 1}`} />
                                                    <p className="legend">{event.title}</p>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </Paper>
                                )}
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Container>

                <Footer />
            </>
        );
    }
}

export default PublicEvents;
